module.exports = __webpack_public_path__ + "img/gratitude-journal_B095L5M1ZR.08b23507.jpg";